import { useState, useCallback } from "react";
import log from "../../outfitting/logger";
import { extractUnifiedIDs } from "../utils";
import { FM_EVENTS, trackFMEvent } from "../fm-analytics/fm-analytics";
import { useRouter } from "next/router";

const useQuickViewModal = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const { locale } = useRouter();

  const handleProductSelected = useCallback((event, itemSelected) => {
    if (event.ctrlKey || event.metaKey) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();

    let outputProduct = {
      productId: null,
      selectedProductUID: null,
      categoryUID: null,
      productPosition: null,
      images: [],
      productUrl: null,
    };

    try {
      const colorId = itemSelected?.uni?.split("||")[1] || "";
      const unifiedIDs = extractUnifiedIDs(itemSelected?.item_url);
      const currentPage = Boolean(itemSelected.page) ? itemSelected.page : 1;
      const currentPosition = parseFloat(
        `${currentPage}.${itemSelected?.position}`
      );
      outputProduct.productId = itemSelected?.details?.product_id;
      outputProduct.productPosition = currentPosition;
      outputProduct.categoryUID = unifiedIDs?.[0] || "";
      outputProduct.selectedProductUID = unifiedIDs?.[1] || "";
      outputProduct.images = itemSelected?.details?.original_images || [];
      outputProduct.productUrl = itemSelected?.item_url;
      outputProduct.colorId = colorId;
      if (itemSelected?.lookId !== undefined) {
        trackFMEvent(FM_EVENTS.ITEM_CLICK, locale, {
          response_uuid: itemSelected?.uuId,
          item_id: itemSelected?.details?.product_id,
          set_id: itemSelected?.lookId,
          featured: itemSelected?.featured,
        });
      }
    } catch (err) {
      log.error(err, {
        tags: {
          componentName: "OutfittingInspirationComponent",
          functionName: "handleProductSelected",
          featureName: "OutfitsInspirationV2",
        },
      });
    }

    if (!outputProduct?.selectedProductUID) {
      log.error(new Error("No Product unified id from findmine item"), {
        tags: {
          componentName: "OutfittingInspirationComponent",
          functionName: "handleProductSelected",
          featureName: "OutfitsInspirationV2",
        },
      });
    }
    setSelectedProduct(outputProduct);
  }, []);

  return {
    selectedProduct,
    setSelectedProduct,
    handleProductSelected,
  };
};

export default useQuickViewModal;
